import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "../../../../redux/store";
import {
	IOption,
	IVDMDashboardContent,
} from "redux/app/vdmdashboard/@types";
// import CardAlertPill from "./_elements/CardAlertPill";

type OwnProps = {
	data?: IVDMDashboardContent["currentlyAt"];
};
type Card1Props = PropsFromRedux & OwnProps;
function Card1(props: Card1Props) {
	const { data } = props;
	if (!data) return null;
	const { fuelMode, state, timezone } = data;
	const currentPosition = data?.currentPosition;

	const metricsToShow = [
		{
			label: "Time Zone",
			value: timezone,
		},
		{
			label: "Fuel mode",
			value: fuelMode?.join(", "),
		},
		{
			label: "State",
			value: state,
		},
	];

	const getCurrentLocation = (
		currentPosition: IVDMDashboardContent["currentlyAt"]["currentPosition"],
	) => {
		let subTitle = "";
		switch (currentPosition.status) {
			case "STEAMING":
				subTitle =
					currentPosition?.status === "STEAMING"
						? `Lat - ${currentPosition?.coordinates?.latitude} \nLong - ${currentPosition?.coordinates?.longitude}`
						: currentPosition?.portName
							? `Port of ${currentPosition?.portName}`
							: "Not available";
				break;
			case "PORT":
				subTitle = currentPosition?.portName
					? `Port of ${currentPosition?.portName}`
					: "NA";
				break;
			default:
				subTitle = "";
		}

		return subTitle;
	};
	return (
		<div className="flex-1 hover:cursor-pointer 2xl:w-full">
			<div className="bg-gradient-to-b from-white to-[#F9FCFE] border border-gray-200 rounded-xl p-4 pr-0 shadow-sm lg:min-w-[256.5px] h-full sm:h-[179px] min-w-[176px] flex flex-col justify-between hover:shadow relative">
				<div className="h-full">
					<div className="flex flex-col justify-between h-full">
						<div>
							<h3 className="text-xs text-gray-800 font-medium mb-1 py-1 border-l-4 border-l-[#3182CE] px-2 bg-gradient-to-r from-[#3182CE29] to-[#3182CE00] w-1/2">
								Currently At
							</h3>
							<p className="text-sm lg:text-base xl:text-lg font-medium text-gray-800 mb-3 whitespace-pre-line">
								{currentPosition && getCurrentLocation(currentPosition)}
							</p>
						</div>
						<div className="space-y-2 text-xs">
							{metricsToShow?.map((metric: IOption, index: number) => {
								const { label, value } = metric;
								return (
									<div key={label + value} className="flex gap-2 items-center">
										<span className="text-gray-500 font-medium inline-block w-[60px]">
											{label}
										</span>
										<span className="text-gray-700 font-medium">{value}</span>
									</div>
								);
							})}
						</div>
					</div>

					{/* INFO: Not part of phase-1 */}
					{/* <div className=" right-0 top-0 mt-2 absolute flex flex-col items-end">
						{highPriority?.map((alert) => {
							return <CardAlertPill key={alert} alert={alert} type="error" />;
						})}
						{lowPriority?.map((alert) => {
							return <CardAlertPill key={alert} alert={alert} type="warning" />;
						})}
					</div> */}
				</div>
			</div>
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(Card1);
